import { render, staticRenderFns } from "./FormStep.vue?vue&type=template&id=640dc87e&scoped=true"
import script from "./FormStep.vue?vue&type=script&lang=js"
export * from "./FormStep.vue?vue&type=script&lang=js"
import style0 from "./FormStep.vue?vue&type=style&index=0&id=640dc87e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640dc87e",
  null
  
)

export default component.exports